export default __webpack_public_path__ + "static/hero-bg-59ee3d34eb65046f37c60565cbf94448.jpg";